module.exports = __webpack_public_path__ + "static/media/calculadoras.de534187.svg";